import React from 'react';
import { Chip } from '@mui/material';
import UserStatus from '../../../types/UserStatus';

interface RenderUserStatusProps {
  status: UserStatus;
}

function RenderUserStatus({
  status
}: RenderUserStatusProps): React.ReactElement | null {
  if (status === 'ACTIVE')
    return <Chip label='Active' variant='outlined' color='success' />;
  if (status === 'SUSPENDED')
    return <Chip label='Suspended' variant='outlined' color='error' />;
  if (status === 'INVITATION_PENDING')
    return (
      <Chip label='Invitation Pending' variant='outlined' color='warning' />
    );
  return null;
}

export default RenderUserStatus;
